import styled from '@emotion/styled';
import { createElement, FC } from 'react';

type Props = {
  className?: string;
};

const YahooDevice169: FC<Props> = (props) => (
  <Root viewBox="0 0 145.78 300.88" {...props}>
    <defs>
      <style>
        {
          '.yahoo16-9_svg__cls-1{fill:#fff}.yahoo16-9_svg__cls-2{fill:none;stroke:#f5f5f5;stroke-miterlimit:10}.yahoo16-9_svg__cls-3{fill:#9e9e9e}.yahoo16-9_svg__cls-8{fill:#eee}.yahoo16-9_svg__cls-9{fill:#f8b02c}'
        }
      </style>
    </defs>
    <g id="yahoo16-9_svg__\u30EC\u30A4\u30E4\u30FC_2" data-name="\u30EC\u30A4\u30E4\u30FC 2">
      <g id="yahoo16-9_svg__\u30EC\u30A4\u30E4\u30FC_1-2" data-name="\u30EC\u30A4\u30E4\u30FC 1">
        <rect width={145.78} height={300.88} rx={21.72} />
        <path
          className="yahoo16-9_svg__cls-1"
          d="M6.28 39.65h132.07v21.96H6.28zM138.27 39.65v-18A14.31 14.31 0 00124 7.33h-14.16v1.92a7.59 7.59 0 01-7.59 7.59H43.14a7.59 7.59 0 01-7.59-7.59V7.33h-15A14.31 14.31 0 006.28 21.64v18z"
        />
        <path
          className="yahoo16-9_svg__cls-1"
          d="M6.28 60.24v219a14.31 14.31 0 0014.31 14.31H124a14.31 14.31 0 0014.31-14.31v-219z"
        />
        <path
          className="yahoo16-9_svg__cls-2"
          d="M6.46 36.17h131.65M6.46 156.87h131.65M6.46 174.22h131.65M6.46 198.78h131.65"
        />
        <circle className="yahoo16-9_svg__cls-3" cx={129.32} cy={25.68} r={4.77} />
        <rect className="yahoo16-9_svg__cls-3" x={7.4} y={161.21} width={23.3} height={9.87} rx={2.63} />
        <rect className="yahoo16-9_svg__cls-3" x={60.27} y={161.21} width={23.3} height={9.87} rx={2.63} />
        <rect className="yahoo16-9_svg__cls-3" x={86.71} y={161.21} width={23.3} height={9.87} rx={2.63} />
        <rect className="yahoo16-9_svg__cls-3" x={113.15} y={161.21} width={23.3} height={9.87} rx={2.63} />
        <rect x={33.84} y={161.21} width={23.3} height={9.87} rx={2.63} fill="#ff5666" />
        <path fill="#eb4441" d="M6.32 38.53H138.4v73.2H6.32z" />
        <path d="M114.93 20.41H97.22V31.8h17.71a5.48 5.48 0 005.22-5.7 5.47 5.47 0 00-5.22-5.69z" fill="#1e74ff" />
        <path d="M18.62 20.41a5.47 5.47 0 00-5.22 5.69 5.48 5.48 0 005.22 5.7H96.3V20.41z" fill="#e7e7e7" />
        <path
          className="yahoo16-9_svg__cls-3"
          d="M21.32 115.83h17.12v17.12H21.32zM41.66 115.83h17.12v17.12H41.66zM61.99 115.83h17.12v17.12H61.99zM82.32 115.83h17.12v17.12H82.32zM102.66 115.83h17.12v17.12h-17.12zM21.32 136.79h17.12v17.12H21.32z"
        />
        <path className="yahoo16-9_svg__cls-8" d="M30.24 180.22h55.23v4.21H30.24zM44.7 187.57h30.11v4.21H44.7z" />
        <rect className="yahoo16-9_svg__cls-9" x={30.23} y={186.81} width={12.13} height={5.14} rx={2.57} />
        <path className="yahoo16-9_svg__cls-3" d="M10.36 177.94h17.12v17.12H10.36z" />
        <path className="yahoo16-9_svg__cls-2" d="M6.46 224.97h131.65" />
        <path className="yahoo16-9_svg__cls-8" d="M30.24 206.42h55.23v4.21H30.24zM29.64 213.77h30.11v4.21H29.64z" />
        <path className="yahoo16-9_svg__cls-3" d="M10.36 204.14h17.12v17.12H10.36z" />
        <path className="yahoo16-9_svg__cls-2" d="M6.46 249.53h131.65" />
        <path className="yahoo16-9_svg__cls-8" d="M30.24 230.98h55.23v4.21H30.24zM44.7 238.33h30.11v4.21H44.7z" />
        <rect className="yahoo16-9_svg__cls-9" x={30.23} y={237.57} width={12.13} height={5.14} rx={2.57} />
        <path className="yahoo16-9_svg__cls-3" d="M10.36 228.7h17.12v17.12H10.36z" />
        <path className="yahoo16-9_svg__cls-8" d="M30.24 256.02h55.23v4.21H30.24zM44.7 263.37h30.11v4.21H44.7z" />
        <rect className="yahoo16-9_svg__cls-9" x={30.23} y={262.6} width={12.13} height={5.14} rx={2.57} />
        <path
          className="yahoo16-9_svg__cls-3"
          d="M10.36 253.73h17.12v17.12H10.36zM41.66 136.79h17.12v17.12H41.66zM61.99 136.79h17.12v17.12H61.99zM82.32 136.79h17.12v17.12H82.32zM102.66 136.79h17.12v17.12h-17.12z"
        />
        <path d="M6.3 261.89v17.61a14.3 14.3 0 0014.3 14.31H124a14.31 14.31 0 0014.31-14.31v-17.61z" fill="#ebe5e1" />
        <rect x={53.71} y={286.02} width={34.73} height={3.52} rx={1.76} />
        <circle className="yahoo16-9_svg__cls-3" cx={129.32} cy={272.22} r={4.77} />
        <circle className="yahoo16-9_svg__cls-3" cx={92.43} cy={272.22} r={4.77} />
        <circle className="yahoo16-9_svg__cls-3" cx={53.81} cy={272.22} r={4.77} />
        <circle cx={16.93} cy={272.22} r={4.77} fill="#ec4545" />
      </g>
    </g>
  </Root>
);

const Root = styled('svg')();
export default YahooDevice169;
